// extracted by mini-css-extract-plugin
export default {"map":"placeMap__map___[chunkhash-base64-5]"};